import { render } from "./WorkOrdersByAssetTable.vue?vue&type=template&id=6484ad72"
import script from "./WorkOrdersByAssetTable.vue?vue&type=script&lang=js"
export * from "./WorkOrdersByAssetTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__